import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const UserBarChart = ({ totalPendingUsers, totalApprovedUsers, totalUsers }) => {
  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      {/* Heading */}
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#1976d2',
          mb: 1,
        }}
      >
        User Analytics
      </Typography>

      {/* Card */}
      <Card
        sx={{
          borderRadius: '16px',my:"6vh",
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.3s',
          height: '280px', // Adjust card height
          '&:hover': {
            transform: 'scale(1.02)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <CardContent
          sx={{
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          {/* Bar Chart */}
          <Bar
            data={{
              labels: ['Pending', 'Approved', 'Total'],
              datasets: [
                {
                  label: 'Users',
                  data: [totalPendingUsers, totalApprovedUsers, totalUsers],
                  backgroundColor: [
                    'rgba(255, 99, 132, 0.7)', // Pending - Red
                    'rgba(54, 162, 235, 0.7)', // Approved - Blue
                    'rgba(75, 192, 192, 0.7)', // Total - Teal
                  ],
                  borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(75, 192, 192, 1)',
                  ],
                  borderWidth: 1.5,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top',
                  labels: {
                    color: '#333',
                    font: {
                      size: 12,
                    },
                  },
                },
              },
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  beginAtZero: true,
                  ticks: {
                    color: '#555',
                  },
                  grid: {
                    color: '#ddd',
                  },
                },
              },
            }}
            style={{
              height: '200px', // Chart height to fit card
              width: '100%',
            }}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserBarChart;
